import { useEffect, useState } from "react";
import "@/App.css";
import axios from "axios";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Catalog } from "@/components/Catalog";
import { Manifesto } from "@/components/Manifesto";
import { Footer } from "@/components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function App() {
  const [catalog, setCatalog] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    axios.get(`${API}/catalog`).then((res) => setCatalog(res.data)).catch(() => {});

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain" data-testid="app-root">
      <Navbar company={catalog?.company} />
      <Hero company={catalog?.company} />
      <Marquee />
      <Catalog catalog={catalog} />
      <Manifesto />
      <Footer company={catalog?.company} />
    </div>
  );
}

export default App;
